import { Box } from "@mui/material"
import { getLogoForDomain } from "../Helper/Organization/GuestFunctions";

const LogoContainer = () => {
    const logo = getLogoForDomain(window.location.hostname);
    return (
        <Box
          sx={{ display: "flex", justifyContent: "center", mb: 2, ml: -0.8 }}
        >
          <img src={logo} alt="Organization Logo" height={"40px"} />
        </Box>
    )
}

export default LogoContainer;
